import React, {useEffect, useRef} from "react";

/* Fait apparaître son contenu en douceur lorsqu'il entre dans l'écran. */
export default function Reveal({children, delay = 0, style, className = ""}: {
    children: React.ReactNode; delay?: number; style?: React.CSSProperties; className?: string;
}) {
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        if (!("IntersectionObserver" in window)) { el.classList.add("visible"); return; }
        const io = new IntersectionObserver(([e]) => {
            if (e.isIntersecting) { el.classList.add("visible"); io.disconnect(); }
        }, {threshold: 0.12});
        io.observe(el);
        return () => io.disconnect();
    }, []);
    return <div ref={ref} className={`reveal ${className}`} style={{transitionDelay: `${delay}ms`, ...style}}>{children}</div>;
}
